$(document).ready(function () {
  $('.js-c-history-log-button').click(function () {
    var details = $(this).closest('li').find('.js-details')
    details.toggleClass('hidden')
  })
})
